import React, { useEffect, useState } from "react";
import api from "../utils/api";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle, XCircle, Loader2, ArrowLeft } from "lucide-react";

export default function PaymentStatus() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying");
  const orderId = searchParams.get("order_id");

  useEffect(() => {
    const verifyPayment = async () => {
      try {
        // Small delay to ensure Cashfree has processed the payment
        await new Promise(resolve => setTimeout(resolve, 2000));

        console.log("🔍 Verifying order:", orderId);
        const res = await api.post("/api/payment/verify", { order_id: orderId });
        console.log("✅ Verify response:", res.data);

        if (res.data.status === "success") {
          setStatus("success");
          // Store purchase info for countdown display
          if (res.data.ticketType) {
            localStorage.setItem('recentPurchase', JSON.stringify({
              ticketType: res.data.ticketType,
              purchaseTime: Date.now()
            }));
          }
        } else {
          setStatus("failed");
        }
      } catch (err) {
        console.error("❌ Verification failed:");
        console.error("  Status:", err.response?.status);
        console.error("  Message:", err.response?.data?.message);
        console.error("  Details:", err.response?.data?.details);
        console.error("  Full error:", err.message);
        setStatus("error");
      }
    };

    if (orderId) {
      verifyPayment();
    } else {
      console.error("❌ No order_id found in URL params!");
      setStatus("error");
    }
  }, [orderId]);

  return (
    <div className="status-page">
      <div className="status-card">
        {status === "verifying" && (
          <>
            <Loader2 size={64} className="animate-spin" color="#c9a646" />
            <h2>Verifying Payment...</h2>
            <p>Please do not close this window.</p>
          </>
        )}
        
        {status === "success" && (
          <>
            <CheckCircle size={80} color="#22c55e" />
            <h2 style={{ color: "#22c55e" }}>🎉 Payment Successful!</h2>
            <p>Your seat is reserved. Confirmation details have been sent to your email.</p>
          </>
        )}
        
        {status === "failed" && (
          <>
            <XCircle size={80} color="#ef4444" />
            <h2 style={{ color: "#ef4444" }}>❌ Payment Failed</h2>
            <p>We couldn't process your payment. Please try again or contact support.</p>
          </>
        )}
        
        {status === "error" && (
          <>
            <XCircle size={80} color="#f97316" />
            <h2 style={{ color: "#f97316" }}>⚠️ Verification Error</h2>
            <p>There was a technical error while verifying your payment.</p>
          </>
        )}
        
        <button onClick={() => navigate("/dashboard")} className="back-btn">
          <ArrowLeft size={18} /> Go to Dashboard
        </button>
      </div>
    </div>
  );

}
